import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LoadingAction } from 'src/app/shared/models/loading-action.enum';
import { LiabilityActions } from '../../classes/liability-actions';
import { Liability } from '../../models/liability.model';
import { XsellService } from '../../../billers/services/xsell.service';
import { AnalyticsService } from '../../../core/services/analytics-service';
import { DialogService } from '../../../core/services/dialog.service';
import { PaymentService } from '../../../pay/services/payment.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { LiabilityService } from '../../services/liability.service';
import { TypeformService } from 'src/app/shared/services/typeform.service';
import { LiabilityApiService } from '../../services/liability-api.service';
import { LiabilityItemService } from '../../services/liability-item.service';
import { AppConfig } from '../../../core/services/app-config.service';
import { CartStoreService } from '../../../shared/services/cart.service';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { MatIconButton } from '@angular/material/button';
import { ApiCallLoadingDirective } from '../../../shared/directives/api-call-loading.directive';
import { AsyncPipe, NgIf } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  standalone: true,
  selector: 'app-liability-expandable-menu',
  styleUrls: ['./liability-expandable-menu.component.scss'],
  templateUrl: './liability-expandable-menu.component.html',
  imports: [
    IconComponent,
    MatIconButton,
    ApiCallLoadingDirective,
    RouterLink,
    AsyncPipe,
    MatTooltip,
    NgIf,
  ],
})
export class LiabilityExpandableMenuComponent extends LiabilityActions implements OnChanges, OnInit {
  @ViewChild('downloadPdfLink') public downloadPdfLink: ElementRef;
  @Input() public hover: boolean;
  @Input() public disabled: boolean;
  @Input() public startedPaymentId: string = null;
  @Input() public liability: Liability = null;
  @Output() public liabilityMarkedAsPaidEvent = new EventEmitter<void>();

  public loadingAction = LoadingAction;

  constructor(
    public loadingService: LoadingService,
    router: Router,
    liabilityService: LiabilityService,
    paymentService: PaymentService,
    analyticsService: AnalyticsService,
    xsellService: XsellService,
    dialog: DialogService,
    snackbar: MatSnackBar,
    route: ActivatedRoute,
    typeformService: TypeformService,
    liabilityApiService: LiabilityApiService,
    liabilityItemService: LiabilityItemService,
    appConfig: AppConfig,
    cartStoreService: CartStoreService
  ) {
    super(
      liabilityService,
      paymentService,
      analyticsService,
      xsellService,
      dialog,
      snackbar,
      router,
      route,
      typeformService,
      liabilityApiService,
      liabilityItemService,
      appConfig,
      cartStoreService
  );
  }

  public ngOnInit(): void {
    this.calculateActions();
  }

  public ngOnChanges(): void {
    this.calculateActions();
  }

  public canShowDetails(): boolean {
    return true;
  }
}
